// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoadingTitle_wrapper__3my0A","loading":"LoadingTitle_loading__2iZgB"};